(function () {
  var CHECKOUT_BUTTON_SELECTOR = 'button[name="checkout"]'; // passt auf CartDrawer-Checkout

  // WICHTIG: Nichts zwischenspeichern! Der Cart-Drawer wird nach jedem
  // Warenkorb-Update (Artikel hinzufügen/entfernen/Menge ändern) per AJAX
  // komplett neu gerendert (siehe product-form.js: this.cart.renderContents(...)).
  // Alte, gecachte DOM-Referenzen zeigen danach ins Leere. Deshalb wird hier bei
  // jeder Prüfung frisch nachgeschaut.

  function getCheckboxes() {
    var box = document.getElementById('pv-confirmation');
    return box ? box.querySelectorAll('.pv-check') : [];
  }

  function allChecked() {
    var checks = getCheckboxes();
    if (checks.length === 0) return true; // kein 0%-Artikel im Warenkorb -> nichts zu blockieren
    return Array.prototype.every.call(checks, function (c) { return c.checked; });
  }

  function updateState() {
    var ok = allChecked();
    var checkoutBtn = document.querySelector(CHECKOUT_BUTTON_SELECTOR);
    var errorMsg = document.getElementById('pv-error');
    var hasPvItem = getCheckboxes().length > 0;

    if (checkoutBtn) {
      checkoutBtn.setAttribute('aria-disabled', String(!ok));
      checkoutBtn.style.opacity = ok ? '1' : '0.6';

      if (!hasPvItem) {
        // Kein 0%-Artikel im Warenkorb -> nichts zu blockieren
        checkoutBtn.dataset.pvBlocked = 'false';
      } else if (!ok) {
        checkoutBtn.dataset.pvBlocked = 'true';
      }
      // WICHTIG: Wenn ok === true, wird pvBlocked hier NICHT sofort auf
      // 'false' gesetzt! Das passiert erst in saveConfirmationToCart(),
      // NACHDEM das Speichern der Attribute tatsächlich bestätigt wurde.
      // Sonst entsteht ein Wettlauf: Der Button wirkt schon "entsperrt",
      // während /cart/update.js im Hintergrund noch läuft - klickt die
      // Person in diesem kurzen Fenster auf "Bezahlen", navigiert der
      // Browser weg und bricht die noch laufende Speicherung ab, bevor
      // sie abgeschlossen ist. Genau das führte dazu, dass Bestellungen
      // trotz korrekt gesetzter Checkboxen ohne PV_*-Attribute ankamen.
    }
    if (errorMsg) errorMsg.style.display = ok ? 'none' : 'block';

    if (ok && hasPvItem) saveConfirmationToCart();
  }

  function scrollToConfirmation() {
    var box = document.getElementById('pv-confirmation');
    if (!box) return;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    box.classList.add('pv-highlight');
    setTimeout(function () {
      box.classList.remove('pv-highlight');
    }, 1600);
  }

  // Merkt sich den zuletzt bekannten Cart-Attribute-Stand, damit der
  // pagehide-Notfallversand (siehe unten) auch ohne eigenen Netzwerk-Roundtrip
  // sofort einen brauchbaren mergedAttributes-Datensatz bauen kann.
  var lastKnownCartAttributes = null;
  var confirmationSaved = false;

  function buildDiagnosticNote(eventLabel) {
    return eventLabel + ' | ' + new Date().toISOString() + ' | ' + navigator.userAgent;
  }

  function sendBeaconSafely(payloadObj) {
    try {
      var blob = new Blob([JSON.stringify(payloadObj)], { type: 'application/json' });
      navigator.sendBeacon('/cart/update.js', blob);
    } catch (e) {
      // sendBeacon selbst kann in seltenen Fällen (z. B. sehr alte Browser)
      // fehlen oder fehlschlagen - dann bleibt es beim regulären fetch-Pfad.
    }
  }

  function saveConfirmationToCart() {
    // Sofort-Diagnose: Sobald alle drei Häkchen gesetzt sind, EINEN
    // Best-Effort-Hinweis per sendBeacon abschicken - unabhängig vom
    // eigentlichen Merge/Save weiter unten. sendBeacon ist dafür gebaut,
    // auch dann zuverlässig anzukommen, wenn die Seite currently navigiert -
    // das ist unser Sicherheitsnetz für genau die Fälle, in denen der
    // reguläre fetch-Ablauf aus unbekannten Gründen nicht durchläuft (z. B.
    // Bestellung IOmeter-9648, bei der wir die genaue Ursache nicht mehr
    // rekonstruieren konnten). Läuft der reguläre Pfad normal durch, wird
    // dieser Diagnose-Eintrag gleich danach von den echten PV_*-Attributen
    // überschrieben (siehe Merge unten) und fällt nicht weiter auf.
    sendBeaconSafely({
      attributes: { 'PV_Debug_AlleHaekchenGesetzt': buildDiagnosticNote('checked') }
    });

    // WICHTIG: /cart/update.js ERSETZT den kompletten attributes-Datensatz,
    // statt nur einzelne Schlüssel zu ergänzen. Andere Skripte im Theme
    // (z. B. Tracking-/Marketing-Apps, die eigene Cart-Attribute setzen,
    // wie das beobachtete "_omgLp_cartId") würden unsere PV_*-Attribute sonst
    // überschreiben, wenn sie nach uns einen eigenen update.js-Call machen -
    // und umgekehrt. Deshalb: erst aktuellen Stand holen, dann mergen.
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        lastKnownCartAttributes = cart.attributes || {};
        var mergedAttributes = Object.assign({}, lastKnownCartAttributes, {
          'PV_Betreiber_bestaetigt': 'ja',
          'PV_Leistung_max_30kWp_bestaetigt': 'ja',
          'PV_Verwendungszweck_bestaetigt': 'ja',
          'PV_Bestaetigung_Zeitstempel': new Date().toISOString()
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: mergedAttributes })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('update.js antwortete mit Status ' + res.status);
        confirmationSaved = true;
        // Erst JETZT, nach bestätigtem Speichern, den Button tatsächlich
        // entsperren. Zwischen dem Anhaken der letzten Checkbox und diesem
        // Punkt bleibt der Button gesperrt (kurzzeitig, meist < 1 Sekunde) -
        // ein Klick in diesem Fenster wird abgefangen und scrollt erneut
        // zum Block, statt einen ungespeicherten Checkout zuzulassen.
        var checkoutBtn = document.querySelector(CHECKOUT_BUTTON_SELECTOR);
        if (checkoutBtn) checkoutBtn.dataset.pvBlocked = 'false';
      })
      .catch(function (err) {
        console.error('Konnte Bestätigung nicht speichern:', err);
        // Best-Effort-Diagnose, damit im Nachhinein wenigstens sichtbar ist,
        // DASS und WANN der reguläre Speicherversuch fehlgeschlagen ist.
        sendBeaconSafely({
          attributes: { 'PV_Debug_SpeichernFehlgeschlagen': buildDiagnosticNote(String(err)) }
        });
        // Bei Fehler bleibt pvBlocked auf 'true' -> Button bleibt gesperrt,
        // statt einen unbestätigten Checkout durchzulassen.
      });
  }

  // Notfall-Netz: Falls die Seite verlassen wird (Navigation, Tab-Wechsel,
  // Schließen), BEVOR die reguläre Speicherung bestätigt wurde, versuchen wir
  // hier einen letzten Rettungsversuch per sendBeacon - das ist die von
  // Browsern dafür vorgesehene Technik, die auch inmitten einer Navigation
  // noch zuverlässig zugestellt wird (im Gegensatz zu einem regulären
  // fetch-Aufruf, der bei Navigation abgebrochen werden kann).
  document.addEventListener('pagehide', function () {
    if (confirmationSaved) return;
    if (getCheckboxes().length === 0) return;
    if (!allChecked()) return;

    var mergedAttributes = Object.assign({}, lastKnownCartAttributes || {}, {
      'PV_Betreiber_bestaetigt': 'ja',
      'PV_Leistung_max_30kWp_bestaetigt': 'ja',
      'PV_Verwendungszweck_bestaetigt': 'ja',
      'PV_Bestaetigung_Zeitstempel': new Date().toISOString(),
      'PV_Bestaetigung_Ueber': 'pagehide-notfallversand'
    });
    sendBeaconSafely({ attributes: mergedAttributes });
  });

  // Event-Delegation auf document, in der CAPTURING-Phase (drittes Argument
  // `true`): Das ist entscheidend, weil unser Bestätigungsblock innerhalb von
  // <cart-drawer-items> liegt. Dawns eigener Code registriert dort einen
  // 'change'-Listener, der JEDES change-Event für eine Mengenänderung hält
  // (this.addEventListener('change', debouncedOnChange...)) und dabei auf
  // event.target.dataset.min/step/index zugreift - bei einer Checkbox sind
  // das alles undefined, was zu NaN-Vergleichen, einer falschen
  // "Abstufungen von..."-Fehlermeldung und einem Absturz in
  // resetQuantityInput() führt (dort wird nach einem Element gesucht, das es
  // für unsere Checkbox gar nicht gibt).
  // Mit `true` (Capturing-Phase) läuft unser Listener VOR Dawns
  // Bubble-Phase-Listener; stopPropagation() verhindert, dass das Event dort
  // überhaupt ankommt.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('pv-check')) {
      e.stopPropagation();
      updateState();
    }
  }, true);

  // Klick auf den Checkout-Button abfangen (Capture-Phase, damit wir vor
  // Dawns eigenem Submit-Handler laufen): Wenn nicht bestätigt, Absenden
  // verhindern und stattdessen zum Bestätigungsblock scrollen + hervorheben.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(CHECKOUT_BUTTON_SELECTOR) : null;
    if (!btn) return;
    if (btn.dataset.pvBlocked === 'true') {
      e.preventDefault();
      e.stopPropagation();
      scrollToConfirmation();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', updateState);

  // Nach jedem Cart-Update (Drawer-Inhalt wurde gerade neu ins DOM geschrieben)
  // Zustand neu auswerten -> neuer Button wird sofort wieder korrekt gesperrt,
  // bis die Checkboxen (die beim Re-Render zurückgesetzt sind) erneut gesetzt werden.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(updateState, 0);
    });
  }
})();